import { ApiErrorPageWithTrans } from '@components/Error/ApiErrorPageWithTrans';
import { NoddiLoadingScreenWithTrans } from '@components/Loading/NoddiLoadingScreenWithTrans';
import { Trans } from '@lingui/react/macro';
import { noddiAsync, URLKeys } from 'noddi-async';
import { NoddiBasicCard, NoddiDummyButton } from 'noddi-ui-web';
import { customerRoutes } from 'noddi-util';
import { useCurrentBrand } from '../../../stores/BrandStore/brandStore';
import { formatReferralProgramDiscountLabel } from '../../../utils/referralProgramDisplay';

type Props = {
  userGroupId: number;
};

export const InviteFriendsHome = ({ userGroupId }: Props) => {
  const { currentBrand } = useCurrentBrand();

  const {
    data: referral,
    isPending,
    error
  } = noddiAsync.useGet({
    type: URLKeys.getReferrals,
    input: { userGroupId, brandDomain: currentBrand }
  });

  if (isPending) {
    return <NoddiLoadingScreenWithTrans />;
  }
  if (error) {
    return <ApiErrorPageWithTrans error={error} />;
  }

  const currentRewardLabel = formatReferralProgramDiscountLabel(referral.currentReward ?? []);

  return (
    <div className='flex flex-col gap-2 md:gap-4'>
      <h2 className='text-xl font-bold text-primary md:text-3xl'>
        <Trans>Invite friends</Trans>
      </h2>
      <NoddiBasicCard to={customerRoutes.myReferrals.getPath()} className='flex flex-col gap-5 text-balance'>
        <p className='font-semibold md:text-lg'>
          {currentRewardLabel ? (
            <Trans>Invite friends, earn {currentRewardLabel}</Trans>
          ) : (
            <Trans>Invite friends and earn rewards</Trans>
          )}
        </p>
        <p className='text-sm text-muted-foreground'>
          <Trans>Share your link and track your referrals.</Trans>
        </p>
        <div className='flex justify-end'>
          <NoddiDummyButton variant='link' endIcon='ArrowRight' className='-mr-4 -mb-2'>
            <Trans>See details</Trans>
          </NoddiDummyButton>
        </div>
      </NoddiBasicCard>
    </div>
  );
};
